__turbopack_context__.v({
  "container": "ProfilePicture-module__lll5Pa__container",
  "image": "ProfilePicture-module__lll5Pa__image",
  "placeholder": "ProfilePicture-module__lll5Pa__placeholder",
});
